import { useEffect } from 'react'

import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import { HttpStatusCode } from '@/modules/shared/protocols/http-client.protocol'

import {
  type TProductImageOrderService,
  productImageOrderService,
} from '../services/product-image-order.service'
import { useProductStoreActions } from '../stores/product.store'

export const useProductImageOrderData = () => {
  const { setProductImage, setIsOpenModalProductImage } = useProductStoreActions

  const { axiosRequest: requestProductImage } = useAxiosHttpClient({
    sendRequest: productImageOrderService,
  })

  const handleSubmitHistory = ({ payload }: TProductImageOrderService) => {
    requestProductImage.mutate({ payload, showInfo: true })
  }

  useEffect(() => {
    if (requestProductImage.isSuccess) {
      if (requestProductImage.data.status === HttpStatusCode.OK) {
        setProductImage(JSON.parse(requestProductImage.data.body))
        setIsOpenModalProductImage(true)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestProductImage.isLoading])

  return {
    state: {
      isLoadingProductImageData: requestProductImage.isLoading,
      isLoadingRequest: requestProductImage.isLoading,
    },
    action: {
      onSubmitProductImageRequest: handleSubmitHistory,
    },
  }
}
